import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Layout from "./Layout";

const Home = () => {
  return (
    <Layout>
      <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 8 } }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h1"
            sx={{
              fontFamily: '"Racing Sans One", cursive',
              fontSize: { xs: "2rem", sm: "2.75rem" },
              color: "primary.dark",
              textShadow: "1px 1px 2px rgba(224,182,182,0.6)",
            }}
          >
            Hello!
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontFamily: '"Racing Sans One", cursive',
              fontSize: { xs: "1.25rem", sm: "1.5rem" },
              mt: 1,
              mb: 2,
              color: "primary.main",
            }}
          >
            Welcome to the onboarding portal.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Use the link in your email to complete your New Start form or
            sign your contract.
          </Typography>
        </Box>
      </Container>
    </Layout>
  );
};

export default Home;
